import apiClient, { formatApiError } from "./client";

/**
 * Zugriffsverwaltung (Access Management) API Service
 * Maps to: PasswortDatenbankController + PasswortManagerSecurityController
 * Handles Page 3 operations
 */

export const getAllAccesses = async (oid) => {
  try {
    const response = await apiClient.get(`/api/passwortdatenbank/alle/${oid}`);
    return response.data;
  } catch (error) {
    console.error("getAllAccesses error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der Zugriffe") };
  }
};

export const setActiveDatabase = async (oid, passwortDatenbankId) => {
  try {
    const response = await apiClient.put("/api/passwortdatenbank/aktiv-setzen", { oid, passwortDatenbankId });
    return response.data;
  } catch (error) {
    console.error("setActiveDatabase error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Festlegen der aktiven Datenbank") };
  }
};

export const redeemAccessCode = async (oid, accessCode, aliasName = null) => {
  try {
    const response = await apiClient.post("/api/passwortdatenbank/access-code/einloesen", { oid, accessCode, aliasName });
    return response.data;
  } catch (error) {
    console.error("redeemAccessCode error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Einlösen des Access Codes") };
  }
};

export const generateAccessCode = async (oid, passwortDatenbankId) => {
  try {
    const response = await apiClient.post("/api/passwortdatenbank/access-code/generieren", { oid, passwortDatenbankId });
    return response.data;
  } catch (error) {
    console.error("generateAccessCode error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Erstellen des Access Codes") };
  }
};

export const getPendingRequests = async (oid, passwortDatenbankId) => {
  try {
    const response = await apiClient.get(`/api/passwortdatenbank/pending-requests/${oid}/${passwortDatenbankId}`);
    return response.data;
  } catch (error) {
    console.error("getPendingRequests error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der ausstehenden Anfragen") };
  }
};

export const approveAccess = async (dto) => {
  try {
    const response = await apiClient.post("/api/passwortdatenbank/access/genehmigen", dto);
    return response.data;
  } catch (error) {
    console.error("approveAccess error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Freigeben des Zugriffs") };
  }
};

export const rejectAccess = async (dto) => {
  try {
    const response = await apiClient.post("/api/passwortdatenbank/access/ablehnen", dto);
    return response.data;
  } catch (error) {
    console.error("rejectAccess error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Ablehnen des Zugriffs") };
  }
};

export const updateAlias = async (zugriffId, oid, aliasName) => {
  try {
    const response = await apiClient.put(`/api/passwort-manager/zugriffe/${zugriffId}/alias?oid=${oid}`, { aliasName });
    return response.data;
  } catch (error) {
    console.error("updateAlias error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Speichern des Alias") };
  }
};

export const getAccessCodes = async (oid, passwortDatenbankId) => {
  try {
    const response = await apiClient.get(`/api/passwortdatenbank/access-codes/${oid}/${passwortDatenbankId}`);
    return response.data;
  } catch (error) {
    console.error("getAccessCodes error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden der Access Codes") };
  }
};

export const revokeAccessCode = async (oid, accessCodeId) => {
  try {
    const response = await apiClient.put(`/api/passwortdatenbank/access-code/${accessCodeId}/widerrufen?ownerOid=${oid}`);
    return response.data;
  } catch (error) {
    console.error("revokeAccessCode error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Widerrufen des Access Codes") };
  }
};

export const revokeUserAccess = async (ownerOid, passwortDatenbankId, benutzerId) => {
  try {
    const response = await apiClient.post("/api/passwortdatenbank/access/entziehen", { ownerOid, passwortDatenbankId, benutzerId });
    return response.data;
  } catch (error) {
    console.error("revokeUserAccess error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Entziehen des Zugriffs") };
  }
};

export const endMyAccess = async (oid, passwortDatenbankId) => {
  try {
    const response = await apiClient.post("/api/passwortdatenbank/access/beenden", { oid, passwortDatenbankId });
    return response.data;
  } catch (error) {
    console.error("endMyAccess error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Beenden des Zugriffs") };
  }
};
